import { useAppTranslation } from '@/app/i18n/client';

export function ModulesMessage() {
  const { t } = useAppTranslation(['common']);

  return (
    <p
      className="absolute mb-4 self-center text-center font-semibold min-[480px]:static
        min-[480px]:w-[min(70vw,400px)] sm:text-xl md:text-2xl"
    >
      {t('common:availableModules')}
    </p>
  );
}
